import React from 'react';
import { Header } from 'oxyrion-ui/lib';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Img from 'react-image';
import Loader from 'oxyrion-ui/lib/Loader';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect, actions } from '../../Store';
import { formatPrice, __ } from '../../Utils';
// import OrderImport from '../../Components/OrderImport';
import AlertPopup from '../../Components/AlertPopup';
import nameDays from '../../ContentConfig/namedays';
import nameDaysCZ from '../../ContentConfig/namedays_cz';
import placeholder from '../ProductCatalog/Components/Gallery/placeholder-image.png';
import OrderImport from '../../Components/OrderImport';

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(70)};
`;

const StyledImg = styled(Img)`
  height: ${rem(50)};
  max-width: 100%;
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    let todayName = '';
    let tomorrowName = '';
    try {
      todayName = (this.props.appLang === 'SK' ? nameDays : nameDaysCZ)[
        today.getMonth().toString()
      ][today.getDate().toString()].split(/,/)[0];

      tomorrowName = (this.props.appLang === 'SK' ? nameDays : nameDaysCZ)[
        tomorrow.getMonth().toString()
      ][tomorrow.getDate().toString()].split(/,/)[0];
    } catch (e) {
      todayName = '';
      tomorrowName = '';
    }

    this.state = {
      showImportOrder: false,
      activeCart: 0,
      nameDayToday: todayName,
      nameDayTomorrow: tomorrowName,
    };

    this.headerMenuItems = [
      {
        label: __('Používatelia'),
        onClick: () => {
          this.props.history.push('/settings/users');
        },
        rolesExcluded: ['b2b_user'],
        icon: 'users',
      },
      {
        label: __('Spoločnosť'),
        onClick: () => {
          this.props.history.push('/settings/company');
        },
        rolesExcluded: ['b2b_user'],
        icon: 'building',
      },
      {
        label: __('Môj účet'),
        onClick: () => {
          this.props.history.push('/settings/account');
        },
        rolesExcluded: [],
        icon: 'profile',
      },
      {
        label: __('Odhlásiť sa'),
        onClick: () => actions.logout(),
        rolesExcluded: [],
        icon: 'power-off',
      },
    ];
  }

  componentWillMount() {
    const { activeCart } = this.props;
    try {
      if (activeCart) {
        this.setState({
          activeCart,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.activeCart &&
      this.props.activeCart !== nextProps.activeCart
    ) {
      this.setState({ activeCart: nextProps.activeCart });
    }
  }

  changeCart(e) {
    const value = e.target.value;
    if (value) {
      actions.setActiveCart(value);
      this.setState({ activeCart: value });
    }
  }

  toProducts() {
    localStorage.setItem('menuState', false);
    actions.setMenuState(false);
    actions.setActiveCart(this.state.activeCart);
    this.props.history.push('/buy/catalog');
  }

  render() {
    const { header, user, carts } = this.props;

    const {
      showImportOrder,
      activeCart,
      nameDayToday,
      nameDayTomorrow,
    } = this.state;
    let cartPrice = {
      amount: 0,
      currency: user.firm === 'SK' ? '€' : 'Kč',
    };

    const activeCartLocal = carts.find(c => c._id === activeCart) || carts[0];

    if (!carts && carts.find(c => c._id === activeCart) && carts[0]) {
      cartPrice = carts[0].total_price_vat;
    } else if (
      carts &&
      carts.find(c => c._id === activeCart) &&
      carts.find(c => c._id === activeCart).total_price_vat
    ) {
      cartPrice = carts.find(c => c._id === activeCart).total_price_vat;
    }

    return (
      <React.Fragment>
        <AlertPopup
          display={showImportOrder}
          alignUnderHeader
          onClose={() =>
            this.setState({
              showImportOrder: false,
            })
          }
          component={
            <OrderImport
              toCart={() =>
                this.setState({ showImportOrder: false }, () => {
                  // onShoppingCartClick('/shopping-cart');
                  window.location = '/shopping-cart';
                  this.history.push('/shopping-cart?step=1');
                })
              }
            />
          }
        />
        <Header
          position="fixed"
          name={`${user.name} ${user.surname}`}
          pageTitle={header}
          addLabel={__('Pridať produkt')}
          cartSum={formatPrice(cartPrice)}
          logo="https://www.dejmark.com/public/assets/images/dejmark-logo.svg"
          // onNewOrder={() => onShoppingCartClick('/products')}
          onCart={() => this.props.history.push('/shopping-cart?step=1')}
          logoutMethod={() => actions.logout()}
          onNewProduct={() => this.toProducts()}
          activeCartContent={
            activeCartLocal &&
            activeCartLocal.items.map(i => {
              return {
                item_name: i.item_name,
                price: formatPrice({
                  amount: i.price.amount * i.quantity,
                  currency: i.price.currency,
                }),
                quantity: i.quantity,
                image_content: (
                  <ImageWrapper key={i.image_full_path}>
                    <StyledImg
                      key={i.image_full_path}
                      src={[
                        `${baseURL}/images/270x0/${i.image_full_path}`,
                        placeholder,
                      ]}
                      loader={<Loader color="#70af00" />}
                    />
                  </ImageWrapper>
                ),
              };
            })
          }
          onSettings={() => this.props.history.push(`/settings/account`)}
          onSearch={text => this.props.history.push(`/buy/catalog?q=${text}`)}
          nameDayToday={nameDayToday}
          nameDayTomorrow={nameDayTomorrow}
          searchPlaceholder={__('Hľadať produkt')}
          emptyCartTitle={__('Košík je prázdny')}
          tomorrowLabel={__('zajtra')}
          nameDayLabel={__('Meniny má')}
          toCartTitle={__('Prejsť do košíka')}
          menuOffset={67}
          role={this.props.user.role || 'b2b_user'}
          headerMenuItems={this.headerMenuItems}
          carts={carts
            .filter(
              c =>
                c.title !== 'android' ||
                (c.title === 'android' && c.items && c.items.length > 0),
            )
            .map(cart => {
              if (cart.title === 'cart1') {
                return { ...cart, title: this.props.t('Moja objednávka') };
              }
              if (cart.title === 'android') {
                return { ...cart, title: this.props.t('Mobilná aplikácia') };
              }

              return cart;
            })}
          selectedCart={activeCart}
          changeCart={e => this.changeCart(e)}
        />
      </React.Fragment>
    );
  }
}

NavBar.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
  }),
  header: PropTypes.string,
  onCartChange: PropTypes.func,
};

NavBar.defaultProps = {
  user: {
    name: '',
    surname: '',
    email: '',
    phone: '',
    role: '',
  },
  header: '',
  onCartChange: () => {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default withTranslation()(withRouter(connect(mapStateToProps)(NavBar)));



// WEBPACK FOOTER //
// ./src/Containers/NavBar/index.js